import { I18N_KEYS } from '@/language/keys';

/** Extend this list when adding providers; labels live in i18n under API_KEYS.PROVIDERS. */
export const API_KEY_PROVIDERS = [
  {
    id: 'google',
    labelKey: I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.PROVIDERS.GOOGLE,
    credentialType: 'serviceAccount' as const,
  },
  {
    id: 'fal',
    labelKey: I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.PROVIDERS.FAL,
    credentialType: 'apiKey' as const,
  },
] as const;

export type ApiKeyProviderId = (typeof API_KEY_PROVIDERS)[number]['id'];
export type CredentialType = (typeof API_KEY_PROVIDERS)[number]['credentialType'];
